import styled from "@emotion/styled";
import { KonturColors } from "@skbkontur/colors";

import { sizeToken } from "../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Interactive = styled.div<{ hideActions: boolean }>(
    props => ({
        ...theme(props).typography.primary.css(),
        position: "relative",
        display: "flex",
        flexDirection: "row",
        boxSizing: "border-box",
        padding: theme(props).size([1, 1]),
        [`${ActionsBlock}`]: { visibility: props.hideActions ? "hidden" : "visible" },
    }),
    props => ({
        "&:hover": {
            backgroundColor: theme(props).keyPalette.panelBackgroundColor,
            [`${ActionsBlock}`]: {
                backgroundColor: theme(props).keyPalette.panelBackgroundColor,
            },
        },
    }),
    props =>
        props.hideActions && {
            "&:hover": {
                [`${ActionsBlock}`]: { visibility: "visible" },
            },
        }
);

export const IconContainer = styled.span(props => ({
    flex: "0 0 16px",
    color: theme(props).icons.color,
    marginRight: theme(props).size(0.5),
}));

export const FileNameAndErrorsContainer = styled.div({
    flex: "1 1",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    paddingRight: sizeToken(2),
});

export const FileName = styled.span(() => ({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
}));

export const ProgressContainer = styled.div(_ => ({
    position: "absolute",
    left: sizeToken(3.5),
    right: sizeToken(3.5),
    bottom: sizeToken(0.5),
}));

export const MessageContainer = styled.div(() => ({
    marginTop: -sizeToken(0.5),
}));

export const ActionsBlock = styled.div({
    position: "absolute",
    top: sizeToken(1),
    right: sizeToken(1),

    display: "flex",
    gap: "8px",

    paddingLeft: "4px",

    backgroundColor: KonturColors.grayscaleWhiteFFF,
});

export const ActionButtonContainer = styled.div(props => ({
    userSelect: "none",
    color: theme(props).icons.color,
    cursor: "pointer",

    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));
